import Checkbox from './Checkbox';
import Group from './Group';
Checkbox.Group = Group;
export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/checkbox/index.js
// module id = 109
// module chunks = 14